import styled from 'styled-components';
import React from 'react';
import { FormIcon } from 'components/Form/FormIcon';
import { constants } from '../../constants';


const OuterContainer = styled.div`
    display: flex;
    flex: 1;
    flex-flow: column nowrap;
    padding-bottom: 15px;
    align-self: stretch;
`

const InnerContainer = styled.div`
    display: flex;
    flex: 1;
    background-color: ${constants.color.grey5};
    border-radius: 4px;
    align-items: baseline;
    padding: 0 20px 0;
`

const Input = styled.input`
    display: flex;
    flex: 1;
    border: none;
    background-color: transparent;
    padding: 10px 20px;
    font-size: ${constants.text.baseFontStyles.fontSize - 2}px;
    :focus {
        outline: 1px solid ${constants.color.primary};
        /* outline-color: ${constants.color.primary}; */
    }
`
const InfoField = ({ style, icon, iconStyle='fas', children, ...rest }) => {
    // console.log('props?', ...rest)
    return (
        <OuterContainer className='InfoField-OuterContainer' style={style}>
            <InnerContainer className='InfoField-InnerContainer'>
                {icon && 
                    <div>
                        <FormIcon name={icon} size={20} top={0} iconStyle={iconStyle} style={{marginLeft: 0, marginBottom: -2, color: '#C3C3C3'}}></FormIcon>
                    </div>
                }
                {children}
            </InnerContainer>
        </OuterContainer>
)};

export default InfoField


// WEBPACK FOOTER //
// ./src/js/components/InfoField/InfoField.jsx